import type {PageRouteConfig} from '@router';

import {type HeaderDataPayload} from '@ds/types';
import {useRouteBuildContext} from '@router';
import Orders from 'modules/Orders/Orders';
import {useCallback} from 'react';

function OrdersPageElement() {
  const {updateHeaderData} = useRouteBuildContext();
  const handleHeaderData = useCallback(
    ({icon, action, iconTitle, title}: HeaderDataPayload) => {
      updateHeaderData('orders', {icon, action, iconTitle, title});
    },
    [updateHeaderData]
  );

  return <Orders headerData={handleHeaderData} />;
}

export function createOrdersRoute(): PageRouteConfig {
  return {
    element: <OrdersPageElement />,
    layout: {
      title: 'سفارش‌ها',
      hasNavigate: true,
      hasHeader: true,
      hasBack: false,
      hasLeftIcon: true,
      link: -1,
      headerDataKey: 'orders'
    },
    initialHeaderData: {
      orders: {icon: '', iconTitle: '', action: null, title: ''}
    }
  };
}
